import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.caste;

const getCaste = createSelector(getData, caste => values(caste));

export default getCaste;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getCaste.js